import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useEmitEvent } from '../../../../hooks/analytics/useEmitEvent'
import { TrackingEvents } from '@estercare/ester-shared'
import { ScreeningViewTemplate } from '../../../../components/screening/screeningView/ScreeningTemplate'
import { useSelectUserMarket } from '../../../../state/selectors'
import { useEffect } from 'react'
import { isHealthCallsEnabled } from '../../../../utils/market'

export const ScreeningBookHealthCall = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const emitEvent = useEmitEvent()
  const userMarket = useSelectUserMarket()

  // Redirect non Swedish users to portal home since health calls are not available
  useEffect(() => {
    if (!isHealthCallsEnabled(userMarket)) {
      navigate('/portal', { replace: true })
    }
  }, [userMarket, navigate])

  // Only render if health calls are available
  if (!isHealthCallsEnabled(userMarket)) {
    return null
  }

  return (
    <ScreeningViewTemplate
      pageTitle={t('employee.screening.bookHealthCallPage')}
      screeningTitle={t('employee.screening.bookHealthCallTitle')}
      screeningDescription={t('employee.screening.bookHealthCallDescription')}
      buttonText={t('employee.screening.bookHealthCallButton')}
      onButtonClick={() => {
        navigate('/portal/health-services/health-consultation')
        emitEvent({
          eventType: TrackingEvents.CLICK,
          action: 'screening_book_health_call',
        })
      }}
    />
  )
}
